const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * PostgreSQL `date` values are calendar days, not UTC instants. Parsing them
 * with `new Date('YYYY-MM-DD')` shifts the displayed day for users west of
 * UTC, including Toronto.
 */
const dateForDisplay = (date: string | Date): Date => {
  if (typeof date !== 'string') return date;
  const match = DATE_ONLY_PATTERN.exec(date);
  if (!match) return new Date(date);
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export function formatDateLocalized(
  date: string | Date | null | undefined,
  language: string,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!date) return '';
  const d = dateForDisplay(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString(language === 'en' ? 'en-US' : 'fr-FR', options);
}

export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '';
  const d = dateForDisplay(date);
  if (isNaN(d.getTime())) return '';

  const now = new Date();
  const diffTime = Math.abs(now.getTime() - d.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return 'Today';
  } else if (diffDays === 1) {
    return 'Yesterday';
  } else if (diffDays < 7) {
    return `${diffDays} days ago`;
  } else {
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
}
